import { useEffect, useRef } from 'react';

export default function useEffectAfterMount(fn, deps) {
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }
    fn();
  }, deps);
}
